<div [formGroup]="addressForm">
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Address 1" formControlName="address1"
             [errorStateMatcher]="errorMatcher"/>
      <mat-error>Address is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Address 2" formControlName="address2" />
      <mat-error>Address is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Town/City" formControlName="town" />
      <mat-error>Town/city is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="County/region" formControlName="county" />
      <mat-error>County is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Post code" formControlName="postCode"
             [errorStateMatcher]="errorMatcher"/>
      <mat-error>Postal code is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let c of filteredCountries | async" [value]="c.name">
          {{c.name}}
        </mat-option>
      </mat-autocomplete>
      <input matInput
             placeholder="Country"
             formControlName="country"
             [errorStateMatcher]="errorMatcher"
             [matAutocomplete]="auto"
             (blur)="countryBlur()"
             autocomplete="off"
             />
      
  
      <mat-error>Country is required</mat-error>
    </mat-form-field>
  </div>
  